require('normalize.css/normalize.css');
require('../../css/blog/index.scss');

import { navigatePro } from '../utils.js';

document.getElementById('button_container').addEventListener('click', (event) => {
  if (event.target.closest('input') !== null) {
    const search='New%20York,%20NY';
    const state='NY';
    const city='New%20York';
    const category = document.querySelector('input[name=radio-category]:checked').getAttribute('data-id');
    navigatePro(search, state, city, category);
  }
});
